import { apiClient } from './config';

/**
 * Get all users (admin only)
 */
export const getAllUsers = async () => {
  const response = await apiClient.get('/users/users');
  return response.data;
};

/**
 * Update user information (admin only)
 */
export const updateUser = async (userId, userData) => {
  if (userData.custom_client) {
    userData.client = userData.custom_client;
  }
  const response = await apiClient.put(`/users/${userId}`, userData);
  return response.data;
};

/**
 * Delete user (admin only)
 */
export const deleteUser = async (userId) => {
  const response = await apiClient.delete(`/users/${userId}`);
  return response.data;
};

/**
 * Update current user's profile (multipart/form-data)
 */
export const updateMyProfile = async (formData) => {
  const response = await apiClient.put('/profile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};
